module.exports = __webpack_public_path__ + "static/devfestnantes2019-cbf7ace39de6449de80192b212ab1b13.png";